import { usePlanQuery, PlanQuery } from '@/buyers/_gen/gql'

export type PlanSubscription = NonNullable<PlanQuery['planSubscription']>
export type PlanPaymentMethod = NonNullable<PlanQuery['planPaymentMethod']>

export default usePlanQuery
